// extracted by mini-css-extract-plugin
export default {"root":"Deital_root__2i9ms"};